export const NotFoundPage = () => {
    return (
        <div>
            <h2>404</h2>
            <p>not found.</p>
        </div>
    )
}